import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import { useEffect } from 'react'
import { useDateFilter } from '@/common/hooks/useDateFilter'
import { format, startOfDay, endOfDay } from 'date-fns'
import { useQueryState, parseAsString } from 'nuqs'
import useQueryGetPlayerWithDepositPromotion from '@/modules/manage-player/api/hooks/useQueryGetPlayerWithDepositPromotion'
import PlayerWithDepositPromotionListing from '@/modules/manage-player/components/PlayerWithDepositPromotion/components/PlayerWithDepositPromotionListing'

function PlayerWithDepositPromotionDirectPage() {
	const { pageSize, currentPage, searchQuery, channelFilter } =
		useTablePagination()
	const { dateFilter, setDateFilter } = useDateFilter()
	const [dateRange, setDateRange] = useQueryState(
		'dateRange',
		parseAsString.withDefault(''),
	)

	useEffect(() => {
		if (!dateFilter.startDate && !dateFilter.endDate && dateRange !== 'all') {
			const today = new Date()
			setDateFilter({
				startDate: format(startOfDay(today), 'yyyy-MM-dd'),
				endDate: format(endOfDay(today), 'yyyy-MM-dd'),
			})
			setDateRange('today')
		}
	}, [
		dateFilter.startDate,
		dateFilter.endDate,
		dateRange,
		setDateFilter,
		setDateRange,
	])

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		phone: searchQuery,
		channelName: channelFilter || undefined,
		startDate: dateFilter.startDate || undefined,
		endDate: dateFilter.endDate || undefined,
	}

	// Create export params without pagination limits
	const exportParams = {
		phone: searchQuery,
		startDate: dateFilter.startDate || undefined,
		endDate: dateFilter.endDate || undefined,
	}

	const { data, isLoading } = useQueryGetPlayerWithDepositPromotion(payload)

	return (
		<PageContainer>
			<PlayerWithDepositPromotionListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
				showBackButton={false}
				exportParams={exportParams}
			/>
		</PageContainer>
	)
}

const GuardedPlayerWithDepositPromotionDirectPage = withUserPermission(
	PlayerWithDepositPromotionDirectPage,
	{
		permissionType: PermissionType.Read,
		permissionKey: [PermissionKeys.MANAGE_PLAYER],
	},
)

export default GuardedPlayerWithDepositPromotionDirectPage
